export * from './flag-ticket-treshold-count.component';



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/manage/flag-ticket-treshold-count/index.ts